export default () => ({
  campaigns: [
    {
      id: 200001,
      wineId: 100001,
      type: 'wine-of-month',
      active: true,
      price: '6,90',
      discount: '6,00',
      currency: '€',
      description: [
        '',
        'Unser Riesling ist der Gutswein des renommierten VdP-Weingutes Burg Ravensburg aus dem Kraichgau in Baden, etwas südlich von Heilbronn. Das 38 Hektar große Weingut wird im deutschen Weinführer Gault Millau von 2019 mit 4 von 5 Trauben bewertet! Außerdem wird das Weingut seit 2010 ökologisch bewirtschaftet. Wir haben es also mit einem Wein zu tun, der von einem deutschen Spitzenbetrieb biologisch erzeugt wird!',
        'Der Gutsriesling zeigt sich in einem schönen, hellen Strohgelb und erfreut die Nase mit einem Bukett von Zitrusfrucht, Aprikose, Birne und Quitte. Im Mund wirkt der Wein leicht bis mittelgewichtig (nur 11,5 % Vol.) und ist dabei fein und elegant. Die Säure ist angenehm zurückhaltend und im Hintergrund schmeckt man sanft Mineralität. Der Abgang mittellang!',
        'So schön und günstig kann badischer Riesling sein!',
      ],
      media: {
        imgSrc: '/img/wine/burg-ravensburg_riesling_2018.jpg',
      },
      beginCampaign: '2019-05-01T08:00:00.000+02:00',
      endCampaign: '2019-05-31T20:00:00.000+02:00',
      slug: '19-05',
    },
    {
      id: 200002,
      wineId: 100002,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,40',
      currency: '€',
      description: [
        '',
        'Die wunderbar klare Lachsfarbe unseres Spätburgunder Rosé vom Weingut Jesuitenhof von Klaus Schneider aus Dirmstadt, Pfalz, wird durch die weiße Schlegelflasche voll zur Geltung gebracht. Gut gemacht!',
        'Aromen von reifen Limetten, roten Johannisbeeren und intensiver Blütenduft schmeicheln der Nase beim Verkosten. Ein tolles Bukett!',
        'Im Mund wirkt der reine Spätburgunder frisch und enorm spritzig, dabei ist er schlank, feingliedrig und sehr elegant. Absolut trocken endet unser Rosé mit einem mittellangen Abgang!',
        '',
        'Für nur 5,90 € (im Juni 2019 für nur 5,40 €) erhalten Sie reines Trinkvergnügen! Probieren!',
      ],
      media: {
        imgSrc: '/img/wine/jesuitenhof_spaetburgunder-rose_2018.png',
      },
      beginCampaign: '2019-06-01T08:00:00.000+02:00',
      endCampaign: '2019-06-30T20:00:00.000+02:00',
      slug: '19-06',
    },
    {
      id: 200003,
      wineId: 100003,
      type: 'wine-of-month',
      active: true,
      price: '8,00',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Wir bieten Ihnen in diesem Monat eine trockene Cuvée vom Weingut Christian Bamberger aus Bad Sobernheim an der Nahe. Entstanden ist sie aus der spannenden Kombination der drei Rebsorten Silvaner, Sauvignon Blanc und Bacchus und wurde dementsprechend "Vielfalt" genannt. Vielfalt finden wir auch in der komplexen Aromatik wieder: wir entdecken feinfruchtige Noten nach Birnen und Mandarinen vom Silvaner, kräftig fruchtige Noten typisch für den Sauvignon und einen würzigen Muskatton vom Bacchus. Vielfalt ist ausdrucksstark!',
        'Im Mund wirkt der Wein frisch, die Säure ist aber weich und gut eingebunden. Der Wein ist komplex und hat dazu einen schönen, langen und nachhaltigen Abgang!',
        'Unsere Vielfalt harmoniert kulinarisch gut mit leichten Vorspeisen, Gemüsegerichten, asiatischen Reisgerichten, Fisch und Geflügel.',
        'Für 8,00 € (im Juli 2019 für nur 7,50 €) erhalten Sie eine trockene, schön aromatische, ausgewogene und außergewöhnliche Weißweincuvée von einem außergewöhnlichen Nahe-Winzer!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-bamberger_vielfalt_2018.png',
      },
      beginCampaign: '2019-07-01T08:00:00.000+02:00',
      endCampaign: '2019-07-31T20:00:00.000+02:00',
      slug: '19-07',
    },
    {
      id: 200004,
      wineId: 100004,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,40',
      currency: '€',
      description: [
        '',
        'Rosé wird inzwischen von den Verbrauchern berechtigterweise als eigenständiger Weintypus anerkannt. So stieg der weltweite Rosé-Konsum zwischen 2002 und 2015 um erstaunliche 30%!',
        'Eine Modeerscheinung bei Rosé ist die immer heller werdende Farbe. Die Hersteller meinen, dass ein sehr blasses Rosé den Kunden Leichtigkeit und Frische signalisiert. Folgen sie nicht der Mode! Verlassen sie sich auf ihren Geschmack! Auch der tieffarbene Rosé kann leicht und frisch sein!',
        'Unser Rosé vom Staatsweingut Weinsberg stammt von Grundweinen der Rebsorten Lemberger und Spätburgunder. Er füllt das Glas mit klarem, hellem Lachsrot. Sein Bukett ist ausgeprägt und intensiv, es dominieren die Fruchtaromen wie Erd- und Himbeeren und eine angenehme Zitrusnote.',
        'Im Mund wirkt er dank geringer Säure- und Tanninwerte weich, rund und voll. Die Intensität des Fruchtgeschmackes ist recht hoch und er hat einen mittellangen Abgang! Für 5,90 € (Im August für nur 5,40 €) bekommen in diesem Monat einen säurearmen, fruchtbetonten Rosé mit Nachhaltigkeit!',
      ],
      media: {
        imgSrc: '/img/wine/staatsweingut-weinsberg_cuvee-rose_2018.png',
      },
      beginCampaign: '2019-08-01T08:00:00.000+02:00',
      endCampaign: '2019-08-31T20:00:00.000+02:00',
      slug: '19-08',
    },
    {
      id: 200005,
      wineId: 100005,
      type: 'wine-of-month',
      active: true,
      price: '8,00',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Unsere elegante norditalienische Rotwein-Cuvée Inauris 2015, der Name bedeutet "in Gold", siehe auch das goldene Etikett, entstand aus den autochthonen Rebsorten Corvina und Corvinone und den internationalen- oder auch Bordeaux-Rebsorten Merlot und Cabernet Sauvignon. Hinzu kommen noch prägend die Einflüsse des sehr guten Jahrgangs 2015 und eine Holzfasslagerung.',
        'Im Glas zeigt der Inauris eine wunderbar strahlende, rubinrote Farbe. Sein Bukett ist dicht, vielschichtig, sehr komplex. Im Vordergrund stehen die Aromen von roten Beeren und Waldbeeren, dahinter kommen feinwürzige Noten und ein Hauch Bitterschokolade. Der Wein ist feingliedrig, mittelgewichtig und erfreut mit sehr langem Abgang.',
        'Sie bekommen in diesem Monat eine feingliedrige, vielschichtige und nachhaltige Rotweincuvée aus einem sehr guten Jahr zu einem günstigen Preis!',
        'Die ideale Serviertemperatur für den Inauris ist 16° C. Er harmoniert großartig mit Grillgerichten, Wild, Rinderbraten und im Geschmack ausgeprägten Käsen.',
      ],
      media: {
        imgSrc: '/img/wine/casa-vinicola-sartori_inauris_2015.png',
      },
      beginCampaign: '2019-09-01T08:00:00.000+02:00',
      endCampaign: '2019-09-30T20:00:00.000+02:00',
      slug: '19-09',
    },
    {
      id: 200006,
      wineId: 100006,
      type: 'special',
      active: true,
      price: '3,80',
      discount: '',
      currency: '€',
      description: [
        '',
        'Noch einmal zur Erinnerung:',
        'Federweißer ist ein Most, der sich im Stadium der Gärung befindet, natürlich trüb und noch kein fertiger Wein ist. Er hat viele Vitamine, aber wenig Alkohol und ist sehr bekömmlich!',
        '',
        'Bitte stehend transportieren!',
      ],
      media: {
        imgSrc: '/img/feder.jpg',
      },
      beginCampaign: '2019-09-06T08:00:00.000+02:00',
      endCampaign: '2020-09-05T20:00:00.000+02:00',
      slug: 'federweisser',
    },
    {
      id: 200007,
      wineId: 100007,
      type: 'wine-of-month',
      active: true,
      price: '9,90',
      discount: '9,40',
      currency: '€',
      description: [
        '',
        'Unser Tessellae von der Domaine Lafage aus Frankreichs Süden, aus der Nähe von Perpignan hat mit dem Jahrgang 2016 ein neues, schöneres, aussagekräftigeres Etikett bekommen. Der Name, der zu 100% verwendeten Rebsorte Carignan wird deutlich benannt. Aus Carignan werden häufig einfache Weine hergestellt. Nicht im Fall unseres Tessellae! Der Etikett-Zusatz „Vieilles Vignes“ (Alte Reben) bedeutet, dass die Reben im Schnitt älter als 70 Jahre sind.',
        'Alte Reben ergeben extraktreichere Weine. Außerdem erntet die Domaine Lafage nur 20 Hektoliter pro Hektar, bei Landweinen sind sonst 60 – 80 hl / ha üblich, diese Ertragsreduzierung kommt schmeckbar der Qualität des Weines zugute. Seine feine mineralische Note verdankt der Tessellae dem im Süden Frankreichs seltenen Schiefer-Mergel-Boden auf dem er wächst.',
        'Der Tessellae zeigt im Glas ein tiefes, kräftiges und strahlendes Rubinrot. Er duftet intensiv nach reifen Pflaumen, Kirschen und Brombeeren, dahinter folgen Anklänge an Kräutern und Bitterschokolade und eine Spur Mineralität. Im Mund wirkt der Tessellae voll, üppig und rund, er hat keine Ecken und Kanten, ist ausgewogen mit eingebundenen Tanninen und geringer Säure und hat einen schönen, langen Abgang.',
        'Nicht umsonst begeistert uns dieser Wein bereits seit Jahren!',
      ],
      media: {
        imgSrc: '/img/wine/domaine-lafage_tessellae_2017.jpg',
      },
      beginCampaign: '2019-10-01T08:00:00.000+02:00',
      endCampaign: '2019-10-31T20:00:00.000+02:00',
      slug: '19-10',
    },
    {
      id: 200008,
      wineId: 100008,
      type: 'new-wine',
      active: true,
      price: '6,90',
      currency: '€',
      description: [
        '',
        'Unser Riesling Peterhoff ist hellfarbig strohgelb und duftet angenehm nach grünen Äpfeln und Fruchtdrops. Typisch für den Rheingau ist auch eine klare Mineralik. Im Mund spürt man eine feine, spritzige Säure, die den Wein besonders frisch wirken lässt.',
        '',
        'Diesen erfrischenden Riesling aus dem Rheingau lassen wir extra für unsere Einkaufsgemeinschaft von 40 Weinhändlern aus ganz Deutschland bei der Villa Gutenberg abfüllen. Durch die gemein-sam eingekaufte große Menge können wir Ihnen diesen wunderbaren, trockenen, leichten Kabinettwein zu einem besonders günstigen Preis anbieten.',
        '',
      ],
      media: {
        imgSrc: '/img/wine/peterhoff_riesling-kabinett_2018.jpg',
      },
      beginCampaign: '2019-10-01T08:00:00.000+02:00',
      endCampaign: '2019-10-31T20:00:00.000+02:00',
      slug: 'peterhoff-riesling-2018',
    },
    {
      id: 200009,
      wineId: 100009,
      type: 'wine-of-month',
      active: true,
      price: '13,90',
      discount: '13,00',
      currency: '€',
      description: [
        '',
        'Unser Wein dieses Monats kommt aus Südfrankreich aus der näheren Umgebung der berühmten Burg-Stadt Carcassonne und wird aus 4 Rebsorten mit folgender Zusammensetzung erzeugt: 40 % Merlot, 30 % Syrah, 20 % Cabernet Sauvignon und 10% Grenache. Das ist ein für die Gegend typischer "Bordeaux trifft Midi-Stil"! Abgerundet wird das Ganze durch einen moderaten Ausbau in kleinen (225 L) französischen Eichenfässern. Das Ergebnis scheint uns wunderbar gut gelungen!',
        'Übrigens: "Terroirs de Altitude" bezeichnet die Höhenlagen (von 360 m ü.M.) auf denen die Reben für diesen Wein wachsen. Die nächtliche Abkühlung auf dieser Höhe sorgt für die Bildung von ausgeprägten und frischen Fruchtaromen in den Trauben. Und das kann man auch schmecken!',
        'Unser Wein zeigt ein tiefes, dunkles Granatrot; die Nase wird erfreut durch eine vielschichtige Aromatik nach Blaubeeren, Cassis, schwarzen Oliven, Gewürzen und dahinter zarten Noten von Räucherspeck und Leder. Im Mund wirkt er trocken, hat seidige Tannine - die Einflüsse des Barriqueausbaus sind aber deutlich - hat einen vollen Körper und ist sehr nachhaltig!',
        'Sie erhalten in diesem Monat einen komplexen Wein mit viel Kraft, Finesse und Eleganz für die Feiertage am Jahresende!',
      ],
      media: {
        imgSrc: '/img/wine/vignobles-lorgeril_chateau-de-pennautier_2014.jpg',
      },
      beginCampaign: '2019-11-01T08:00:00.000+02:00',
      endCampaign: '2019-11-30T20:00:00.000+02:00',
      slug: '19-11',
    },
    {
      id: 200010,
      wineId: 100010,
      type: 'wine-of-month',
      active: true,
      price: '14,90',
      discount: '14,00',
      currency: '€',
      description: [
        '',
        'Unser neuer Crémant Comtesse de Saint-Pey kommt aus dem Entre-deux-mers-Gebiet, der größten weinerzeugenden Region des Bordeaux. Er wird aus der einheimischen weißen Rebsorte Semillion (zu 70%) und aus der einheimischen roten Rebsorte Cabernet Franc (zu 30%) gekeltert. Diese Mischung bestimmt seinen einzigartigen, unverwechselbaren Charakter! Mit allen Crémants hat er aber die zweite Gärung auf der Flasche gemein, bei der die berauschenden, kleinen, emsig aufsteigenden CO2-Perlchen entstehen. Dieses Schaumwein-Herstellungsverfahren nennt man heute méthode traditionnelle, früher méthode champenoise (Champagnerverfahren).',
        'Im Glas funkelt die Comtesse de Saint-Pey in hellem, strahlendem Strohgelb. Sie erfreut unsere Nase mit vielschichtigen Aromen nach Brioche, Hefe, Grapefruit, reifen Äpfeln, Quitten und einem Hauch weißer Blüten. Im Mund wirkt sie wunderbar erfrischend dank ihrer mundfüllenden, cremig-feinen und stetigen Perlage und ihrer Leichtigkeit (nur 12% Vol.). Dabei ist sie von hoher Geschmacksintensität und schließt mit einem langen Nachhall.',
        'Wir bieten Ihnen im Dezember einen leichten, aber intensiven Crémant – so wie er sein sollte - mit kräftiger, ausdauernder Perlage und lang anhaltendem Nachgeschmack! Und schließen uns vollständig der Kürzestbeschreibung des Herstellers an: "… elegant, delikat, raffiniert …"!',
      ],
      media: {
        imgSrc: '/img/wine/prodiffu-landerrouat_comtesse-de-saint-pey_2017.png',
      },
      beginCampaign: '2019-12-01T08:00:00.000+02:00',
      endCampaign: '2019-12-31T20:00:00.000+02:00',
      links: [
        {
          name: '[Weinwissen: Die Geschmacksabstufungen beim Sekt nach Restzucker]',
          uri: '/l/wissen-sekt',
        },
      ],
      slug: '19-12',
    },
    {
      id: 200011,
      wineId: 100011,
      active: true,
      type: 'wine-of-month',
      price: '6,30',
      discount: '5,80',
      currency: '€',
      description: [
        'Unser Castillo de Almansa Roble wird in der Provinz Albacete in Kastilien-La Mancha im südöstlichen Spanien erzeugt. Er entsteht in der renommierten Bodega Piqueras der Familie Bonete zu je 50% aus den Rebsorten Monastrell und Garnacha tintorera. Der Begriff „Roble“ gibt an, dass der Wein nach Fertigstellung 3 – 4 Monate in einem 300 Liter-Eichenfass gereift wurde. Und übrigens: das Bild auf dem Etikett zeigt tatsächlich das historische Castillo de Almansa.',
        'Die Farbe des Castillo de Almansa Roble ist ein schönes, sehr tiefes Kirschrot mit leichten violetten Reflexen. In die Nase steigt uns ein sanftes Bukett nach reifen Kirschen und schwarzen Beeren, dahinter Anklänge vom Eichenfassausbau: Leder, Kakao und Kaffee. Alles ist gut eigebunden – der Wein ist harmonisch!',
        'Im Mund wirkt er trocken, ist mittelkräftig mit einem intensiven, langen Abgang. Er hat viel Charakter, dank niedriger Säurewerte und reifer Tannine ist er wunderbar sanft und samtig. Wir empfehlen ihn bei 16° zu trinken!',
        '',
        'Der Wein ist - im Monat Januar - für nur 5,80 € ein grandioses Schnäppchen!!!',
      ],
      media: {
        imgSrc: '/img/wine/bodegas-piqueras_castillo-de-almansa-roble_2016.png',
      },
      beginCampaign: '2020-01-01T08:00:00.000+02:00',
      endCampaign: '2020-01-30T20:00:00.000+02:00',
      slug: '20-01',
    },
    {
      id: 200012,
      wineId: 100012,
      type: 'wine-of-month',
      active: true,
      price: '7,30',
      discount: '6,50',
      currency: '€',
      description: [
        '',
        'Unser 2019er Novello Veneto IGT stammt aus Valdobbiadene im nördlichen Venezien, dem Stammland des Prosecco, von einem der bekanntesten und besten Prosecco-Erzeuger: der Tenuta Villa Sandi. Dieser junge Wein wurde aus den beiden kräftigen Bordeaux-Reben Cabernet Franc und Cabernet Sauvignon gekeltert.',
        'Es ist ein jugendlicher, frischer Wein, der als einer der ersten des Jahres auf Flaschen gefüllt wird, ist aber trotzdem schon trinkfertig und besticht mit tollen Fruchtnoten, recht geringem Alkoholgehalt (11,5 %) und wenigen weichen Tanninen. Er kann und sollte leicht gekühlt bei 14 – 16 ° getrunken werden.',
        '',
        'Mit diesem jungen, fruchtig-erfrischenden Wein aus dem Veneto wird der neue Weinjahrgang 2019 eingeläutet!',
      ],
      media: {
        imgSrc: '/img/wine/villa-sandi_novello_2019.png',
      },
      beginCampaign: '2020-02-01T08:00:00.000+02:00',
      endCampaign: '2020-02-29T20:00:00.000+02:00',
      slug: '20-02',
    },
    {
      id: 200013,
      wineId: 100013,
      type: 'wine-of-month',
      active: true,
      price: '9,60',
      discount: '9,00',
      currency: '€',
      description: [
        '',
        'Das 15 Hektar große Weingut Toni Jost Hahnenhof aus Bacharach wird von Vater Peter und Tochter Cecilia Jost gemeinsam geführt. Das Weingut besitzt Weinberge in den beiden Weinbaugebieten Rheingau und Mittelrhein und ist Mitglied im VdP (Verband Deutscher Prädikats- und Qualitätsweingüter), er-kennbar am VdP "Traubenadler" auf der Kapsel oder dem Schraubverschluss jeder Flasche.',
        'Es ist ein jugendlicher, frischer Wein, der als einer der ersten des Jahres auf Flaschen gefüllt wird, ist aber trotzdem schon trinkfertig und besticht mit tollen Fruchtnoten, recht geringem Alkoholgehalt (11,5 %) und wenigen weichen Tanninen. Er kann und sollte leicht gekühlt bei 14 – 16 ° getrunken werden.',
        '',
        'Mit diesem jungen, fruchtig-erfrischenden Wein aus dem Veneto wird der neue Weinjahrgang 2019 eingeläutet!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-toni_jodocus_2017.png',
      },
      beginCampaign: '2020-03-01T08:00:00.000+02:00',
      endCampaign: '2020-03-31T20:00:00.000+02:00',
      slug: '20-03',
    },
    {
      id: 200014,
      wineId: null,
      wineIds: [100014, 100015],
      type: 'wine-of-month',
      active: true,
      prices: ['9,30', '9,30'],
      discounts: ['8,80', '8,80'],
      currency: '€',
      description: [
        '',
        'Das 58 Hektar große Weingut Dürnberg befindet sich im traditionsreichen Weinort Falkenstein, dem historischen Herzen des Weinviertels in Niederösterreich. Seit dem 12. Jahrhundert ist der Weinbau hier belegt. Unsere beiden Weine zeigen deutlich, dass der Weinbau hier im Laufe der Zeit einen sehr hohen Qualitätsstand erreicht hat!',
        '',
      ],
      detailDescriptions: [
        [
          'Grüner Veltliner Falkenstein, Weinviertel DAC, der Klassiker der Region präsentiert ein helles Strohgelb, riecht nach frischer, grüner Apfelfrucht und Zitrusfrüchten außerdem Anklänge an weißen Pfeffer, alles ergänzt durch feine mineralische Noten. Übrigens: eine Befragung von Sommeliers hat ergeben, dass sie in ihrer Mehrzahl den Grünen Veltliner für den passenden Wein zu Spargelgerichten halten! Also: Unbedingt probieren!',
        ],
        [
          'Unsere Cuvée Falko ist eine wunderbar gelungene Verbindung aus den Rebsorten Muskateller, Welschriesling und ein wenig Sauvignon Blanc. Aus dem Glas steigt ein intensives, komplexes Bukett von Flieder- und Holunderblüten unterlegt mit Fruchtaromen von Quitte und Mandarine. Im Mund wirkt er angenehm frisch bei milder Säure und erfreut im Abgang mit einer schönen Länge. Eine gute Wahl für gesellige Stunden! Und Falko macht Lust auf ein zweites Glas!',
        ],
      ],
      media: [
        {
          imgSrc: '/img/wine/weingut-durnberg_veltliner_2019.jpg',
        },
        {
          imgSrc: '/img/wine/weingut-durnberg_falko_2019.jpg',
        },
      ],
      beginCampaign: '2020-04-01T08:00:00.000+02:00',
      endCampaign: '2020-04-30T20:00:00.000+02:00',
      slug: '20-04',
    },
    {
      id: 200015,
      wineId: 100016,
      type: 'wine-of-month',
      active: true,
      price: '7,90',
      discount: '7,40',
      currency: '€',
      description: [
        '',
        'Die Weinberge des 15 Hektar großen Weingutes Friedrich Altenkirch in Lorch haben eine glückliche Lage. Die Reben wachsen oberhalb des Rheins auf einem einzigartigen Terroir, auf mineralischem Schieferboden, und durch die bis zu 60 Grad steile Hanglage in Kombination mit der hohen Sonneneinstrahlung des Rheingaus sind beste Voraussetzungen für die Erzeugung von Spitzenweinen gegeben. Erkauft wird diese gute Qualität durch extreme Anstrengungen, so werden die Trauben in der Steillage zu 100% von der Hand gelesen!',
        'Die goldgelbe Cuvée Boogie 2019 ist eine gekonnte Verbindung aus den verwen-deten Rebsorten Weißburgunder, Riesling, Sauvignon blanc, Scheurebe und Ri-vaner. Vielfältig wie die Rebauswahl fallen dann auch die Aromen im Wein aus. Im Vordergrund steht eine deutliche, frische Zitrusfruchtnote, begleitet von ei-nem herrlichen Duft nach grünem Apfel, dahinter noch ein Hauch von Pfirsich und eine Spur Mineralität. Das alles bei einer sehr dezenten Restsüße, die die Fruchtaromen noch unterstützt, und einer angenehmen Leichtigkeit, unser Boo-gie hat nur 12 % Volumen Alkohol.',
        'Wir bieten Ihnen im Mai einen leichten, fruchtbetonten und harmonischen Wein aus dem Rheingau – nicht nur – für schöne Sommertage!',
        'Achtung: die im Boogie verwendeten Rebsorten werden - bis auf den Riesling - im Weingut Altenkirch nur auf kleiner Fläche angebaut, deshalb ist der Boogie leider meist schon früh im Jahr ausgetrunken!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-altenkirch_boogie_2019.png',
      },
      beginCampaign: '2020-05-01T08:00:00.000+02:00',
      endCampaign: '2020-05-31T20:00:00.000+02:00',
      slug: '20-05',
    },
    {
      id: 200016,
      wineId: 100017,
      type: 'wine-of-month',
      active: true,
      price: '6,00',
      discount: '5,50',
      currency: '€',
      description: [
        '',
        'Bitte beachten: Ein bemerkenswert hübsches Detail bei diesem Wein ist das Etikett. Hier ist den Vignerons de Berticot der Versuch gelungen, die beschwingte Leichtigkeit ihres Weines sinnbildlich darzustellen!',
        'Unser Landwein Le Petit Berticot Sauvignon IGP strahlt hell-strohgelb im Glas. Der Sauvignon ist eine aromatische Rebe und deshalb erfasst unsere Nase einen intensiven sauberen Duft nach frisch gemähtem Gras, nach grünem Apfel und Noten von Zitrusfrucht.',
        'Alles sehr angenehm und recht typisch für einen leichten, frischen Sauvignon mit nur 12 % Volumen Alkohol. Im Mund ist Le Petit Berticot Sauvignon weich und rund mit feinem Säurespiel und endet schön mit mittlerer Länge.',
        'Sie bekommen in diesem Monat puren Trinkgenuss in Form eines leichten, frischen, fruchtigen französischen Landweins des aktuellen Jahrgangs! Wohl bekomm´s!',
      ],
      media: {
        imgSrc: '/img/wine/berticot_le-petit_2019.jpg',
      },
      beginCampaign: '2020-06-01T08:00:00.000+02:00',
      endCampaign: '2020-06-30T20:00:00.000+02:00',
      slug: '20-06',
    },
    {
      id: 200017,
      wineId: 100018,
      type: 'wine-of-month',
      active: true,
      price: '7,30',
      discount: '6,80',
      currency: '€',
      description: [
        '',
        'Das Weingut Heitlinger liegt südlich von Heidelberg im idyllischen Kraichgau in Baden und ist mit seinen 80 Hektar Anbaufläche eins der größten ökologisch arbeitenden Weingüter Deutschlands. Außerdem ist das Weingut Mitglied im renommierten VdP (Verband Deutscher Prädikats- und Qualitätsweingüter), erkennbar am VdP- "Traubenadler" auf der Kapsel oder dem Schraubverschluss jeder Flasche. Mit 4 von 5 Trauben im führenden deutschen Weinführer Gault & Millau zählt das VDP-Gut zu Badens Top-Erzeugern und „macht den Sprung an die deutsche Spitze“, zeigt sich jedenfalls Gault & Millau überzeugt.',
        'Der Heitlinger Rosé 2019 ist eine gelungene Cuvée aus den Rebsorten Pinot Noir (Spätburgunder) und Pinot Meunier (Schwarzriesling) und zeigt im Glas ein herrliches, helles Kirschrot. Er duftet kräftig nach roten Beeren wie Erd- und Himbeeren und hat in der Nase süßliche Noten nach Fruchtdrops und Karamell. Im Mund ist er dann frisch, fruchtig und belebend – auch durch seine leichte, gelöste Kohlensäure – ist dabei durchaus kräftig im Geschmack, mittelgewichtig und hat einen erfreulich langen Abgang',
        '',
        'Das alles bei nur 11% Volumen Alkohol! Sehr charmant!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-heitlinger_rose_2019.png',
      },
      beginCampaign: '2020-07-01T08:00:00.000+02:00',
      endCampaign: '2020-07-31T20:00:00.000+02:00',
      slug: '20-07',
    },

    {
      id: 200018,
      wineId: 100019,
      type: 'wine-of-month',
      active: true,
      price: '6,90',
      discount: '6,40',
      currency: '€',
      description: [
        '',
        'Unser trockener Riesling Peterhoff aus dem Rheingau des neuen Jahrgangs 2019 ist hellfarbig strohgelb und duftet angenehm nach Zitronen, grünen Äpfeln und Fruchtdrops. Typisch für den Rheingau ist auch seine deutliche Mineralik. Im Mund spürt man seine feine, spritzige, aber nicht aggressive, Säure, die den Wein angenehm frisch wirken lässt.',
        '',
        'Diesen erfrischenden Riesling aus dem Rheingau lassen wir extra für unsere Einkaufsgemeinschaft von 40 kleinen selbständigen Weinhändlern aus ganz Deutschland bei der Villa Gutenberg abfül-len. Durch die gemeinsam eingekaufte große Menge können wir Ihnen diesen wunderbaren, trockenen, leichten Kabinettwein zum gleich günstigen Preis wie im letzten Jahr anbieten!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/peterhoff_riesling-kabinett_2018.jpg',
      },
      beginCampaign: '2020-08-01T08:00:00.000+02:00',
      endCampaign: '2020-08-30T20:00:00.000+02:00',
      slug: '20-08',
    },
    {
      id: 200019,
      wineId: 100020,
      type: 'wine-of-month',
      active: true,
      price: '9,50',
      discount: '9,00',
      currency: '€',
      description: [
        '',
        'Das Wahrzeichen von Villa Sandi ist die historische Villa, erbaut 1622 als Sommerresidenz der venezianischen Familie Sandi. Sie ist nicht nur der Sitz des gleichnamigen Weingutes in Valdobbia-dene, dem Kerngebiet des Prosecco, sondern sie ziert das Eti-kett jeder Flasche des Weingutes. Die Weinberge erstrecken sich über die bekanntesten DOC und DOCG-Gebiete Venetiens. 2019 wurden die Weinberge des Valdobbiadene zum UNESCO Weltkulturerbe ernannt.',
        'Villa Sandi produziert Prosecchi und Sekte nach der Martinotti Charmat Methode. Die moderne Kellertechnik und die Kühlung des Mostes ermöglichen die Konservierung der natürlichen Frucht der Trauben. Dies kommt deutlich schmeckbar der Quali-tät unseres Rosé Sektes »Il Fresco« aus den Rebsorten Glera, Chardonnay, Pinot Nero zugute.',
        'Mundus Vini 2019: Silber; Wine Spectator: Top 100 Values. Er zeigt sich zart lachsfarben mit einer langanhaltenden, feinen Perlage. Seine sanfte Fruchtnote aus Erd- und Himbeeren sowie Rosen- und Hagebuttenblüten werden von einem ausgewoge-nen Süße-Säure-Spiel abgerundet. Perfekt als Aperitif oder mit Meeresfrüchten oder asiatischen Gerichten!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/villa-sandi_rose_ilfresco.png',
      },
      beginCampaign: '2020-09-01T08:00:00.000+02:00',
      endCampaign: '2020-09-30T20:00:00.000+02:00',
      slug: '20-09',
    },
    {
      id: 200020,
      wineId: 100021,
      type: 'new-wine',
      active: true,
      price: '9,00',
      currency: '€',
      description: [
        '',
        'Endlich ist wieder eine rebsortenreine Scheurebe im Sortiment! Von vielen lang erwartet – soeben eingetroffen! Seien Sie nicht scheu, fragen Sie nach einem Probeschluck! Es lohnt sich! Die Scheurebe ist eine weiße Rebsorte mit viel aromatischer Ähnlichkeit zum Sauvignon Blanc. Die Rebsorte wurde 1916 von Georg Scheu in Alzey gezüchtet. Er ging davon aus, dass die beiden Rebsorten Riesling und Silvaner die Eltern seien. 2012 widerlegten Wissenschaftler dies durch DNA-Analysen. Die Kreuzungspartner waren demnach der Riesling und die Bukett-rebe, die wiederum eine Kreuzung aus Silvaner und Trollinger ist.',
        'Im Glas zeigt unsere Scheurebe ein glänzendes, helles Stroh-gelb mit zarten grünlichen Reflexen. Das deutsche Weininstitut schrieb einmal: "Scheurebe – ihrem Duft kann man sich schwer entziehen!" Richtig: wir entdecken eine Vielfalt an Aromen von schwarzen Johannisbeeren (Cassis), Stachelbeeren, Grapefruit, aber auch von exotischen Früchten wie Mango und Maracuja. Im Mund wirkt die Scheurebe relativ leicht, sie erfreut durch ih-re animierende Säure und einen mittellangen Abgang! Es bleibt dabei: man kann sich dieser Scheurebe nur schwer entziehen!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-bamberger_scheurebe_2019.png',
      },
      beginCampaign: '2020-07-01T08:00:00.000+02:00',
      endCampaign: '2020-07-31T20:00:00.000+02:00',
      slug: 'weingut-bamberger-scheurebe-2019',
    },
    {
      id: 200021,
      wineId: 100022,
      type: 'new-wine',
      active: true,
      price: '8,90',
      currency: '€',
      description: [
        '',
        'Pinot Noir steht auf dem Etikett, also ist ein deutscher Spät-burgunder in der Flasche. Charakteristisch für diese deutsche, rote Leitrebe ist das helle, strahlende Rubinrot des Weines und sein typisches Bukett mit deutlichen Aromen nach roten und schwarzen Beeren, etwas Minze, frischen Kräutern und einer de-zenten Holznote. Im Mund wirkt der Wein recht weich und rund, ist elegant strukturiert und dabei mittelgewichtig bei nur 12,5 % Alkohol. Er hat spürbare, aber runde, weiche Tannine und ist mittellang im Abgang!',
        'Probieren Sie den Pinot Noir 2018 doch einmal zu Lammloins oder einen Rehrücken!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-gaul_pinot-noir_2018.png',
      },
      beginCampaign: '2020-08-01T08:00:00.000+02:00',
      endCampaign: '2020-08-30T20:00:00.000+02:00',
      slug: 'weingut-gaul-pinot-noir-2018',
    },
    {
      id: 200022,
      wineId: 100023,
      type: 'wine-of-month',
      active: true,
      price: '9,90',
      discount: '9,50',
      currency: '€',
      description: [
        '',
        'Unser Traluna ist ein Landwein aus der Toscana. Das 37 Ha grosse historische Weingut Villa Trasqua liegt zwischen Siena und Monteviggioni. Deshalb besteht seine Cuvée auch zu 70% aus der Chianti-Leitrebe Sangiovese, zu gleichen Teilen ergänzt durch die internationalen Reben Cabernet Sau-vignon und Merlot. Diese Zusammenstellung ist sehr gelungen!',
        'Der Wein zeigt ein schönes mitteltieffarbiges Rubinrot und besticht in der Nase durch fruchtige Noten von Waldbeeren und dunklen Kirschen mit einer feinen Note nach Gewürzen. Im Mund ist er ausgewogen, ohne Ecken und Kanten, mit weichen Tanninen, süßlichen Noten und einem anhaltenden Nachgang. Wir empfehlen als Trinktemperatur 14° bis 16°C.',
        'Die Kombinationsmöglichkeiten zum Essen sind vielfältig: probieren sie ihn zu rotem Fleisch oder Spaghetti Bolognese!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/villa-trasqua_traluna_2018.png',
      },
      beginCampaign: '2020-10-01T08:00:00.000+02:00',
      endCampaign: '2020-10-31T20:00:00.000+02:00',
      slug: '20-10',
    },
    {
      id: 200023,
      wineId: 100024,
      type: 'wine-of-month',
      active: true,
      price: '17,90',
      discount: '16,50',
      currency: '€',
      description: [
        '',
        'Bitte nicht verwechseln: bei einem Vino Nobile di Montepulciano handelt es sich um einen Wein aus dem Städtchen Montepulciano im Süden der Tos-kana und nicht um einen Wein aus der Rebsorte Montepulciano!',
        'Unser Vino Nobile besticht durch ein schönes, mitteltiefes Rubinrot, er duftet intensiv nach Sauerkirschen und Bombeeren mit einer zarten Unternote nach Pfeffer. Unverkennbar sind auch die Töne vom Holzfass, Röstaromen nach Kaffee und Kakao.',
        'Der Wein der Fattoria Talosa ist charaktervoll und kräftig, dabei aber fein und elegant. Sein Abgang ist langanhaltend, die Tannine sind relativ weich, die Weinsäure liegt für die Rebsorte Sangiovese im unteren Bereich. Der Wein ist ein typischer Toskana-Sangiovese mit Bariqueausbau und kann noch einige Jahre gelagert werden.',
        '',
      ],
      media: {
        imgSrc: '/img/wine/fattoria-della-talosa_vino-nobile_2014.png',
      },
      beginCampaign: '2020-11-01T08:00:00.000+02:00',
      endCampaign: '2020-11-30T20:00:00.000+02:00',
      slug: '20-11',
    },
    {
      id: 200024,
      wineId: 100025,
      type: 'wine-of-month',
      active: true,
      price: '15,50',
      discount: '14,50',
      currency: '€',
      description: [
        '',
        'Der bekannte Weinführer "Der kleine Johnson" lobt die Sektmanufaktur Schloss Vaux als "überragenden Sekthersteller".',
        'Die Geschichte von Schloss Vaux begann mit der Gründung 1868 in Berlin! Es wurde das Château Vaux nebst Weinbergen in der Nähe von Metz gekauft und dort stellte man dann 40 Jahre deutschen Sekt her. Mittlerweile residiert Schloss Vaux in Eltville im Rheingau und widmet sich der Herstellung von Spitzensekte aus Rheingauweinen nach der traditionellen Methode in klassischer Flaschengärung.',
        'Unsere Sekt-Cuvée Brut der Sektmanufaktur Schloss Vaux entsteht aus den Rebsorten Weißburgunder, weißgekeltertem Spätburgunder und Riesling und bleibt 21 Monate auf dem Hefelager! Ihre Farbe ist ein zar-tes, helles Strohgelb und sie hat eine feine und stetige Perlage. Unsere Nase entdeckt fruchtig-frische Aromen nach Zitrusfrüchten, Äpfeln, Ap-rikosen und Melonen. Am Gaumen erleben wir die erfrischende Säure des Rieslings, die Fülle und den cremigen Schmelz der Burgunderrebsorten. Zum Schluss er-freut uns ein Nachhall mit schöner Länge.',
        'Ich fand im Internet einen Spruch, der wunderbar die Qualität der Sekte von Schloss Vaux auf den Punkt bringt: Schloss Vaux ist "…Sekt für Leu-te, die es sich leisten können, keinen Champagner zu trinken!"',
      ],
      media: {
        imgSrc: '/img/wine/schloss-vaux_cuvee-brut.png',
      },
      beginCampaign: '2020-12-01T08:00:00.000+02:00',
      endCampaign: '2020-12-31T20:00:00.000+02:00',
      slug: '20-12',
    },
    {
      id: 200025,
      wineId: 100026,
      type: 'wine-of-month',
      active: true,
      price: '8,10',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Unser Wein des Monats im Januar 2021 kommt aus Chusclan, aus dem südlichen Rhône-Tal, der Region unterhalb von Lyon, zwischen Vienne und Avignon. Hier herrschen sowohl klimatisch als auch geologisch extrem gute Bedingungen für den Weinanbau. Die Römer haben deshalb dort bereits vor 2000 Jahren Wein angebaut!',
        'Unser Côtes du Rhône Prieurs de St. Julien 2018 in der 1-Liter Flasche ist eine Cuvée von Weinen aus den Rebsorten Grenache Noir (70%), Carignan, Syrah und Cinsault. Eine klassich-charakteristische Rhône-Mischung, die sich auch im Geschmack widerspiegelt! Der Wein zeigt im Glas ein tiefes, brilliantes Rubinrot. In der Nase dominiert ein schönes Bouqet nach Erd- und Himbeeren, dahinter ein Hauch von getrockneten Pflaumen und eine zarte Pfeffernote. Im Mund wirkt der Côtes du Rhône ansprechend weich, seidig, unkompliziert und vollmundig. Die Qualität dieses Weines erreicht das Niveau vieler höher bewerteter Côtes du Rhône Villages und hat zu recht seine Goldmedallie verdient!',
        'Der Prieurs de St. Julien ist ein guter Begleiter von gebratenem oder gegrilltem Rindfleisch oder Lamm und Wild (Hirsch).',
        '',
      ],
      media: {
        imgSrc: '/img/wine/chusclan_st-julien_2018.png',
      },
      beginCampaign: '2021-01-01T08:00:00.000+02:00',
      endCampaign: '2021-01-31T20:00:00.000+02:00',
      slug: '21-01',
    },
  ],
})
